$(document).ready(function(){
  
  $('.hero-slider').slick({
    infinite: true,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToScroll: 1,
    arrows: false,
    dots: true
  });


  $('.most-loved-gragrances-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 300,
    infinite: true,
    autoplaySpeed: 5000,
    autoplay: false,
    prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0720/6817/0005/files/Arrow_l.png?v=1676889412" class="arrow-left">',
    nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0720/6817/0005/files/Arrow_r.png?v=1676889407" class="arrow-right">',
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('.customer-list').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  const listViewButton = document.querySelector('.list-view-button');
  const gridViewButton = document.querySelector('.grid-view-button');
  const list = document.querySelector('ul#product-grid');
  
  listViewButton.onclick = function () {
    list.classList.remove('grid-view-filter');
    list.classList.add('list-view-filter');
    listViewButton.classList.add('active');
    gridViewButton.classList.remove('active');
  }
  
  gridViewButton.onclick = function () {
    list.classList.remove('list-view-filter');
    list.classList.add('grid-view-filter');
    listViewButton.classList.remove('active');
    gridViewButton.classList.add('active');
  }  
  
});